import { useEffect } from 'react';

const PopUpLightBox = ({ src, onClose }: { src: string; onClose: () => unknown }) => {
  useEffect(() => {
    window.open(src, '_blank');
    onClose();
  }, [src, onClose]);
  return null;
};

export default PopUpLightBox;
